import React from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import MarketShare from "instructor/components/dashboard/market-share";
import Revenues from "instructor/components/dashboard/revenues";
import GrossMargins from "instructor/components/dashboard/gross-margins";
import SharePrice from "instructor/components/dashboard/share-price";
import ReturnOnEquity from "instructor/components/dashboard/return-on-equity";
import ReturnOnAssets from "instructor/components/dashboard/return-on-assets";
import EarningsPerShare from "instructor/components/dashboard/earnings-per-share";

const PerformanceModal = styled(Modal)`
  background: rgba(0, 0, 0, 0.8) !important;

  .modal-dialog {
    width: 1100px !important;

    .modal-content {
      padding: 20px !important;
      border-radius: 4px !important;
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25) !important;
      border: none !important;
    }
  }
`;

const ModalBody = styled(Modal.Body)`
  padding: 0 !important;
`;

const availableComponents = {
  "Market Share": MarketShare,
  Revenues: Revenues,
  "Gross Margins": GrossMargins,
  "Share Price": SharePrice,
  RoE: ReturnOnEquity,
  RoA: ReturnOnAssets,
  EPS: EarningsPerShare
};

const PerformancePopup = ({
  show,
  onHide,
  type,
  metricsReports,
  teams,
  constants,
  currentGame,
  roundNumber
}) => {
  const PopupContent =
    type in availableComponents ? availableComponents[type] : null;
  return (
    <PerformanceModal
      show={show}
      onHide={onHide}
      backdropClassName="transparent-backdrop"
    >
      <ModalBody>
        {PopupContent && (
          <PopupContent
            constants={constants}
            teams={teams}
            metricsReports={metricsReports}
            currentGame={currentGame}
            roundNumber={roundNumber}
          />
        )}
      </ModalBody>
    </PerformanceModal>
  );
};

export default PerformancePopup;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-popup.js